import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export default function EditWorkOrderMenuItem(props: BitumioMenuItem<any>) {
  const { closeMenu, object } = props;
  const navigate = useNavigate();

  const handleEdit = useCallback(() => {
    navigate(`/fleet/work-orders/${object.id}/edit`);
    closeMenu();
  }, [object.id, navigate, closeMenu]);

  return <MenuItem onClick={handleEdit}>Edit</MenuItem>;
}
